module.exports = __webpack_public_path__ + "assets/media/day35.290e5e30.mp3";